<script lang="ts" setup>
	defineProps<{
		isPending: boolean
		title?: string
		subTitle?: string
		iconName: string
		iconDir: string
		useBtn?: boolean
		activateText?: string
		pathClass?: string
		useReminder?: boolean
	}>()
	const emits = defineEmits<{
		(event: 'activate'): void
		(event: 'reminder'): void
	}>()
</script>

<template>
	<div v-show="isPending">
		<shared-empty-state title-class="text-gray-600 !text-base" class="mt-10 text-center">
			<template #title>
				<slot name="title">
					{{ title }}
				</slot>
			</template>
			<template #description>
				<slot name="subTitle">
					<div class="mt-3 text-sm text-gray-500" v-html="subTitle" />
				</slot>
			</template>

			<template #icon>
				<slot name="icon">
					<lazy-tools-icon
						:icon="iconName"
						:dir="iconDir"
						:path-class="pathClass"
						:height="120"
						:width="120"
						class="mt-5 block"
					/>
				</slot>
			</template>
		</shared-empty-state>
		<slot v-if="useBtn" name="button-group">
			<button
				type="button"
				aria-label="Activate policy"
				class="default-btn bottom-0 my-5 w-full justify-center bg-primary-2"
				@click="emits('activate')"
			>
				{{ activateText || 'Activate Policy' }}
			</button>
			<button
				v-show="useReminder"
				type="button"
				aria-label="Activate policy"
				class="w-full justify-center py-2 font-medium text-primary-2"
				@click="emits('reminder')"
			>
				Send Activation Reminder
			</button>
		</slot>
	</div>
</template>
